
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/quickreply",
      function () {
        return require("private-next-pages/compare/quickreply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/quickreply"])
      });
    }
  